export const pagina404titulo = "Esta página no esta disponible"
export const pagina404Descripcion = `
La página que está solicitando no se encuentra disponible 
o se ha producido algún inconveniente. Para continuar 
volver para atras o eliga una de las siguientes opciones:`